<!-- Custom Dialog Overlay -->
<div class="dialog-overlay" (click)="onOverlayClick($event)">
  <div class="filter-dialog" (click)="$event.stopPropagation()">
    <div class="dialog-header">
      <h2 class="dialog-title">Filters</h2>
      <button class="close-btn" (click)="close()">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M18 6L6 18M6 6L18 18" stroke="#666" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>
    
    <div class="dialog-content">
      <div class="filter-row">
        <div class="filter-input-container">
          <label class="filter-label">Name</label>
          <input type="text" class="filter-input" [(ngModel)]="filters.name" placeholder="Enter Name" />
        </div>
      </div>
      
      <!-- Head Filter Row (mirrors company dialog structure) -->
      <div class="filter-row">
        <div class="filter-input-container">
          <label class="filter-label">Head</label>
          <div class="custom-select" [class.open]="isDropdownOpen" (click)="toggleDropdown()">
            <div class="select-trigger">
              <span class="selected-value">{{ getSelectedLabel() || 'Type' }}</span>
              <div class="arrow" [class.rotated]="isDropdownOpen">
                <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 1.5L6 6.5L11 1.5" stroke="#666" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
            </div>
            <div class="options" *ngIf="isDropdownOpen">
              <div 
                class="option" 
                *ngFor="let head of headList" 
                (click)="selectOption(head); $event.stopPropagation()"
                [class.selected]="filters.head_id === head.emp_id"
              >
                {{ head.displayText }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="dialog-actions">
      <button class="btn btn-secondary" (click)="clearFilters()">
        Remove All Filters
      </button>
      <button class="btn btn-primary" (click)="applyFilters()">
        Apply
      </button>
    </div>
  </div>
</div>